














import Vue from 'vue';
import NodeTree from './NodeTree.vue';
import TransitionExpand from '../../ui/TransitionExpand.vue';
import { Component, Prop } from 'vue-property-decorator';
import { RootTree, TreeData } from '@/templates/Tree';
import { parseLanguageHelper } from '@/heplers';
import { parseHrefHelper } from '@/heplers/stringHelpers';

@Component({
  components: {
    NodeTree,
    TransitionExpand,
  },
  filters: {
    parseHref: parseHrefHelper,
    parseLanguage: parseLanguageHelper,
  },
})
export default class Tree extends Vue {
  @Prop(Object) treeData: RootTree;

  isShowChildren(child: TreeData) {
    if (!this.$route.meta.fqdn) return;
    if (!child.fqdn) return;

    const rootFqdnArray = this.$route.meta.fqdn.split('.');
    const childFqdnArray = child.fqdn.split('.');

    return (
      child.children &&
      this.$route.meta.fqdn.includes(child.fqdn) &&
      rootFqdnArray[0] === childFqdnArray[0]
    );
  }
}
